import { useState, useEffect } from "react";

// 1 second = 100ms in test env to speed up tests
const interval = process.env.NODE_ENV === "test" ? 100 : 1000;

export const useRedirect = (
  shouldRedirect: boolean,
  redirectUrl: string | undefined = undefined,
  timer = 3
) => {
  const [secondsLeft, setSecondsLeft] = useState<number>(timer);

  useEffect(() => {
    if (shouldRedirect && redirectUrl) {
      if (secondsLeft === 0) {
        const rootWindow = window.top || window;
        rootWindow.location.href = redirectUrl;
      } else {
        const timer = setTimeout(() => {
          setSecondsLeft(secondsLeft - 1);
        }, interval);
        return () => {
          clearTimeout(timer);
        };
      }
    }
  }, [shouldRedirect, redirectUrl, secondsLeft]);

  return secondsLeft;
};
